import { createSlice } from "@reduxjs/toolkit";
import { fetchVendorItems } from "./VendorThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchVendorItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendorItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchVendorItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default vendorSlice.reducer;